import React from 'react';

const JS_HTML_Objects = () => {
  return (
    <div >
      <h1>JS_HTML_Objects</h1>
      <p>Placeholder component for: "JS HTML Objects"</p>
    </div>
  );
};

export default JS_HTML_Objects;
